import { Locale } from "@common/constans";
import { CabinClass, IDictionary, IOriginDestination, ITraveler, Locality, PassengerType, TravelDocType } from "@common/models";
import Divider from "@components/general/Divider";
import Icon from "@components/general/Icon";
import { Culture } from "@core/index";
import { formatToDateTime, getAirport } from "@utilize/Format";
import bwipjs from 'bwip-js';
import { FC, useEffect } from "react";

interface IBoardingPassItemProps {
    originDestination: IOriginDestination;
    traveler: ITraveler;
};

const BoardingPassPrintItem: FC<IBoardingPassItemProps> = ({ originDestination, traveler }) => {
    const UsLocale = Culture.getLocale(Locale.en);
    const IrLocale = Culture.getLocale(Locale.fa);
    const cabinClass: IDictionary<string> = {
        a: "PRE ECONOMY CLASS",
        y: "ECONOMY CLASS",
        c: "BUSSINUS CLASS"
    }

    const departureDateTime = Culture.getDateTimeInstance(UsLocale.code);
    departureDateTime.setTime(originDestination.departureDateTime);

    const documentType: TravelDocType = originDestination.locality === Locality.International ? TravelDocType.PSPT
        : traveler.nationality?.code !== IrLocale.countryCode ? TravelDocType.PSPT
            : TravelDocType.IDCD;

    useEffect(() => {
        try {
            bwipjs.toCanvas(`pdf417Scanner${traveler.paxNo}`, {
                bcid: 'pdf417',
                text: (traveler.tickets && traveler.tickets[0].keyBoarding) || "",
                scale: 3,
                height: 7,
                width: 27,
                includetext: true,
                textxalign: 'center',
            });
            bwipjs.toCanvas(`pdf417Scanner1${traveler.paxNo}`, {
                bcid: 'pdf417',
                text: (traveler.tickets && traveler.tickets[0].keyBoarding) || "",
                scale: 3,
                height: 7,
                width: 27,
                includetext: true,
                textxalign: 'center',
            });
        } catch (e) {
            // `e` may be a string or Error object
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="check-in-boarding-pass-print-item">
            <main className="check-in-boarding-pass-print-item-container en row spa-0">
                <section className="col-2-3 main-boarding-pass-side">
                    <div className="header-section">
                        <Icon name="icon-mahan-air-logo" />
                        <div className="row spa-1 flex flex-center title">
                            <div className="col-1-auto">Boarding Pass</div>
                            <div className="col-1-auto fa">کارت پرواز</div>
                        </div>
                    </div>
                    <div className="content-section">
                        <div className="row flex spa-2">
                            <div className="col-1-auto bording-alert">
                            </div>
                            <div className="col-1-auto flex-grow">
                                <div className="cabin-class">{cabinClass[`${CabinClass[originDestination.classOfService].toLowerCase()}`]}</div>
                            </div>
                        </div>
                        <div className="row flex flex-no-wrap spa-2">
                            <div className="col-1-auto bording-alert">
                                <div className="fa">لطفا حداقل 45 دقیقه قبل از زمان پرواز در گیت خروجی حضور داشته باشید.</div>
                                <div className="en-alert">PLEASE ENSURE YOU ARE AT THE BOARDING GATE AT LEAST 45 MINUTES BEFORE DEPARTURE TIME.</div>
                            </div>
                            <div className="col-1-auto bording-table">
                                <div className="name-flight-details">
                                    <div className="row spa-2 flex flex-center name">
                                        <div className="col-1-auto title">NAME OF PASSENGER</div>
                                        <div className="col-1-auto desc">{traveler.prefix?.toUpperCase()} {traveler.firstName?.toUpperCase()} / {traveler.lastName?.toUpperCase()}</div>
                                    </div>
                                    <div className="row spa-2 flex flex-center id">
                                        <div className="col-1-auto title">{documentType === TravelDocType.PSPT ? "PASSWORD ID" : "NATIONAL ID"}</div>
                                        <div className="col-1-auto desc">{traveler.travelDocs?.find(td => td.documentType === documentType)?.id}</div>
                                    </div>
                                    <div className="row spa-1 flex flight-details">
                                        <div className="col-1-auto from-to">
                                            <div className="row flex flight-details-items">
                                                <div className="col-1-auto title">FROM</div>
                                                <div className="col-1-auto desc">{originDestination.origin.code?.toUpperCase()}</div>
                                            </div>
                                            <div className="row flex flight-details-items">
                                                <div className="col-1-auto title">TO</div>
                                                <div className="col-1-auto desc">{originDestination.destination.code?.toUpperCase()}</div>
                                            </div>
                                        </div>
                                        <div className="col-1-6 flight-details-items">
                                            <div className="title">CARRIER</div>
                                            <div className="desc">{originDestination.flightSegments[0].provider?.toUpperCase()}</div>
                                        </div>
                                        <div className="col-1-6 flight-details-items">
                                            <div className="title">FLIGHT</div>
                                            <div className="desc">{originDestination.flightSegments[0].flightNumber?.substr(3).toUpperCase()}</div>
                                        </div>
                                        <div className="col-1-6 flight-details-items">
                                            <div className="title">CLASS</div>
                                            <div className="desc">{CabinClass[originDestination.classOfService].toUpperCase()}</div>
                                        </div>
                                        <div className="col-1-6 flight-details-items">
                                            <div className="title">DATE</div>
                                            <div className="desc">{departureDateTime.format("a")} {departureDateTime.format("M").toUpperCase()}</div>
                                        </div>
                                        <div className="col-1-6 flight-details-items">
                                            <div className="title">TIME</div>
                                            <div className="desc">{departureDateTime.format("H:i")}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ticket-seat-information">
                                    <div className="row spa-2 flex">
                                        <div className="col-1-2">
                                            <div className="seat-information">
                                                <div className="flex seat-information-items">
                                                    <div className="title">SEQ NO.</div>
                                                    <div className="desc sequence-number">{traveler.tickets && traveler.tickets[0].sequenceNumber}</div>
                                                </div>
                                                <div className="flex seat-information-items">
                                                    <div className="title">SEAT</div>
                                                    <div className="desc seat-number">
                                                        {
                                                            traveler.tickets?.length ?
                                                                traveler?.paxType === PassengerType.INF ? "INF"
                                                                    : traveler.tickets[0].seatNumber
                                                                : ''
                                                        }
                                                    </div>
                                                </div>
                                                <div className="flex seat-information-items">
                                                    <div className="title">TKT NO.</div>
                                                    <div className="desc ticket-number">{traveler.tickets && traveler.tickets[0].ticketNo}/{traveler.tickets && traveler.tickets[0].couponNo}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-1-2 pdf417-scanner">
                                            <canvas id={`pdf417Scanner${traveler.paxNo}`} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Divider orientation="vertical" mode="perforation" varient="border" />
                <section className="col-1-3 perforation-boarding-pass-side">
                    <canvas id={`pdf417Scanner1${traveler.paxNo}`} />
                    <div className="header-section">
                        <Icon name="icon-mahan-air-logo" />
                    </div>
                    <div className="content-section">
                        <div className="content-section-items name">
                            <div className="title">NAME OF PASSENGER</div>
                            <div className="desc">{traveler.prefix?.toUpperCase()} {traveler.firstName?.toUpperCase()} / {traveler.lastName?.toUpperCase()}</div>
                        </div>
                        <div className="content-section-items">
                            <div className="title">FROM</div>
                            <div className="desc">{getAirport(originDestination.origin.code).otherCityName?.toUpperCase()}</div>
                        </div>
                        <div className="content-section-items">
                            <div className="title">TO</div>
                            <div className="desc">{getAirport(originDestination.destination.code).otherCityName?.toUpperCase()}</div>
                        </div>
                        <div className="content-section-items flight-details">
                            <div className="row spa-1 flex justify-between">
                                <div className="col-1-auto flight-details-items">
                                    <div className="title">FLIGHT</div>
                                    <div className="desc">{originDestination.flightSegments[0].flightNumber?.toUpperCase()}</div>
                                </div>
                                <div className="col-1-auto flight-details-items">
                                    <div className="title">CLASS</div>
                                    <div className="desc">{CabinClass[originDestination.classOfService].toUpperCase()}</div>
                                </div>
                                <div className="col-1-auto flight-details-items">
                                    <div className="title">DATE</div>
                                    <div className="desc">{departureDateTime.format("a")} {departureDateTime.format("M").toUpperCase()}</div>
                                </div>
                                <div className="col-1-auto flight-details-items">
                                    <div className="title">TIME</div>
                                    <div className="desc">{departureDateTime.format("H:i")}</div>
                                </div>
                            </div>
                        </div>
                        <div className="content-section-items boarding-details">
                            <div className="row spa-1 flex justify-between">
                                <div className="col-2-3">
                                    <div className="row spa-1 flex ">
                                        <div className="col-2-3 boarding-details-items">
                                            <div className="title">BOARDING TIME</div>
                                            {
                                                originDestination.flightSegments[0].boardingTime &&
                                                <div className="desc">{formatToDateTime(originDestination.flightSegments[0].boardingTime, { format: "H:i" })}</div>
                                            }
                                        </div>
                                        <div className="col-1-3 boarding-details-items">
                                            <div className="title">GATE</div>
                                            <div className="desc"></div>
                                        </div>
                                    </div>
                                    <div className="row spa-2 flex boarding-details-items">
                                        {
                                            traveler.memberId ? <div className="col-1-2 ">
                                                <div className="title">FFP</div>
                                                <div className="desc">{traveler.memberId}</div>
                                            </div>
                                                : ""
                                        }
                                        <div className="col-1-2 boarding-details-items">
                                            <div className="title">SEQ NO.</div>
                                            <div className="desc sequence-number">{traveler.tickets && traveler.tickets[0].sequenceNumber}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-1-3 boarding-details-items seat-information-items">
                                    <div className="title">SEAT</div>
                                    <div className="seat-number">
                                        {
                                            traveler.tickets?.length ?
                                                traveler?.paxType === PassengerType.INF ? "INF"
                                                    : traveler.tickets[0].seatNumber
                                                : ''
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="content-section-items ticket-number">
                            <div className="title">TKT NO.</div>
                            <div className="desc">{traveler.tickets && traveler.tickets[0].ticketNo}/{traveler.tickets && traveler.tickets[0].couponNo}</div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default BoardingPassPrintItem;